
<template>

 <v-card v-role="roles">
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
     <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
     <v-btn
                  to="preparar-certificado"
                  class="mx-2"
                  fab
                  dark
                  color="primary"
                  v-on="on"
                >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>

        <!-- MENSAGEM DE ERROR **************************-->
             <div v-if="errorInternet" class="text-center">
                <v-icon v-if="errorInternet" large color="orange darken-2">error</v-icon><br>
                <span v-if="errorInternet"  style="font-size:14px;margin-auto;"><b>Upss</b>, não foi possível estabeler a conexão com os nossos servidores.</span><br>
                <span style="font-size:14px;">Queira por favor verificar a sua conexão de <b>internet</b> e tentar novamente.</span><br>
                <span>Para ter acesso ao processo de preparação de <b>certificados</b>,deve ter conexão a <b>internet.</b></span>
             </div>
            <!-- -->
   <v-card-title>
      <span  v-if="!errorInternet">Lista dos Estudantes da turma</span>

        <v-chip
              v-if="!errorInternet"
              class="ma-2"
              close
              color="pink"
              label
              outlined
              >
              {{this.$store.state.objturma.descricao}}
          </v-chip>

          

      <v-spacer></v-spacer>
      <v-row style="position:fixed;background-color:yellow;" v-if="progresso2">
                       <v-col  >
                        <v-progress-circular
                        :size="50"
                        color="green"
                        indeterminate
                      ></v-progress-circular>
                      <span style="font-size:15px;">O certificado abrirá em uma nova janela...Por favor aguarde</span>
                      </v-col>

                </v-row>
     </v-card-title>
     
    <div style="position:fixed;background-color:green;color:white;" v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>
  <v-data-table v-if="!errorInternet"
    :headers="headers"
    :items="listEstudantfromPauta"
    :items-per-page="200"
    class="elevation-1">
    <template v-slot:item.status="{ item }">

      <span
  :style="(item.emitirCertificado == 1 || item.certificado == 1)
    ? (item.resultado === 'Transita' ? 'color:green;' : 'color:#d1740a;')
    : 'color:red;'"
>
  <v-icon
    :color="(item.emitirCertificado == 1 || item.certificado == 1)
      ? (item.resultado === 'Transita' ? 'green' : 'warning')
      : 'red'"
  >
    {{
      (item.emitirCertificado == 1 || item.certificado == 1)
        ? (item.resultado === 'Transita' ? 'mdi-check' : 'mdi-alert')
        : 'mdi-close'
    }}
  </v-icon>
  {{
    (item.emitirCertificado == 1 || item.certificado == 1)
      ? (item.resultado === 'Transita' ? 'Preparado' : 'Preparação incompleta')
      : 'Não Preparado'
  }}
</span>





    </template>
    <template v-slot:item.status_resultado="{ item }">
       <span v-if="item.resultado !== 'Transita'" :style="item.resultado  === 'Transita'?'color:green;':'color:red;'" >{{(item.resultado !== 'Transita')?'Não Transita':'Transita'}}</span>
    </template>

     <template  v-slot:item.imprimir="{ item }">
       <v-btn v-if="(item.emitirCertificado == 1 || item.certificado == 1) && item.resultado === 'Transita' && item.instituicao !== 7 " @click="certificadoPago(item)" fab small  color="green"><v-icon>print</v-icon></v-btn>
       <v-btn v-if="(item.emitirCertificado == 1 || item.certificado == 1) && item.resultado !== 'Transita' && item.instituicao === 7 " @click="certificadoPago(item)" fab small  color="green"><v-icon>print</v-icon></v-btn>

    </template>

    <template v-slot:item.action="{ item }">
        
       
        <v-chip color="blue darken-2" v-if="item.certificadoImpresso === '1'"   outlined>
          O certificado já foi impresso e não pode ser preparado novamente.
        </v-chip>
         <div v-else>
         <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn v-if="item.resultado === 'Transita'" :disabled="item.resultado !== 'Transita'" small    text   @click="Preparar(item)"
                  v-on="on"
                >
                    {{item.emitirCertificado == 1 || item.certificado == 1 ?'Preparar Novamente':'Preparar'}}

                </v-btn>
                <span v-if="item.resultado !== 'Transita' && (idinstituicao !== 7 && idinstituicao !== 144 && idinstituicao !== 5)" style="color:red;">
                  Deve lançar as notas finalista
                </span>

                <v-btn
                  v-if="item.resultado !== 'Transita' && (idinstituicao === 7 || idinstituicao === 144 || idinstituicao === 5)"
                  small
                  text
                  @click="Preparar(item)"
                  v-on="on"
                >
                  {{ item.emitirCertificado == 1 || item.certificado == 1 ? 'Preparar Novamente' : 'Preparar' }}
                </v-btn>

              </template>
              <span v-if="item.resultado === 'Transita'">Clique aqui para Preparar ou Re-preparar o certificado</span>
         </v-tooltip>
        </div>
    </template>
  ></v-data-table>


  <!-- =======================USED FOR SHOW THE MODAL MESSAGE============================== -->


  <v-dialog
      v-model="dialog_modelo_certificado"
      persistent
      max-width="410"
    >
      <v-card>
        <v-card-title class="headline"><v-icon color="yellow">info</v-icon>Alerta</v-card-title>

        <v-card-text>
          Entre em contacto com o Director Pedagógico do ITSLuanda (MAIANGA) para definição do modelo de certificado para este curso.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialog_modelo_certificado = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>





  <!-- =====================================================-- >


  <!--======================================= MODAL =======================================-->
<v-row justify="center">
    <v-dialog v-model="dialog_2" persistent max-width="700px">

      <v-card>
        <v-overlay :value="overlay2">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
        <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col sm="4" cols="12" md="4">

<v-btn text    @click="closeDialog()"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

     <v-col sm="7" cols="12" md="6">  <!--  form titlte section   {{ formTitle }}-->
      Actualização de dados Pessoais
          <v-progress-circular
                v-if="progresso"
                indeterminate
                color="green"
        ></v-progress-circular>
     </v-col>

     

  </v-row>
                  </v-toolbar>

              </template>
<v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
        <v-card-text>
          <v-container>
            <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Nome completo" v-model="editedItem.nome" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field required
                        :rules="ruleBI"
                        v-model="editedItem.bi"
                        :label="descricao"
                        v-mask="mascara" ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                      <v-switch   @change="outroDoc()"></v-switch>
                </v-col>
              <v-col cols="12" sm="6" md="3">
                 <template>

                  <v-menu
                    ref="menubi"
                    v-model="menubi"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field

                        v-model="editedItem.dataemissaobi"
                        :rules="[v => !!v || 'Campo obrigatorio!']"
                        label="Data de emissâo do BI"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker"
                      max="2030-12-31"
                      min="1950-01-01"
                      v-model="datebi"
                      @change="saveDatebi"
                    ></v-date-picker>
                  </v-menu>
                </template>
              </v-col>
              <v-col cols="12" md="4">

                      <v-text-field
                      v-model="editedItem.nomedopai"
                      label="Filho de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.nomedamae"

                        label=" e de:"
                      ></v-text-field>
                    </v-col>
              <v-col cols="12" md="4">
                   <template>

                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field

                              v-model="editedItem.datanascimento"
                              :rules="[v => !!v || 'Campo obrigatorio!']"
                              label="Data de nascimento"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                        </template>
                          <v-date-picker
                            ref="picker"

                            v-model="date"
                          max="2008-12-31"
                            min="1950-01-01"
                            @change="saveDate"
                          ></v-date-picker>
                        </v-menu>
                      </template>

                    </v-col>
              </v-row>
              <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                         v-model="proviSelectedForComb"
                         :items="provincias"
                         item-value="idProvicia"
                          item-text="descricao"
                          @change="loadMunicipioComb"
                          @click="loadMunicipioComb"

                        chips
                        label="Natural de:"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="municSelectedForComb"
                        :items="municipiosFiltered"
                        item-value="idMunicipio"
                        item-text="descricao"
                        chips
                        label="Municipio"
                      ></v-combobox>
                    </v-col>
                     <v-col cols="12" md="4">
                      <v-combobox
                        v-model="editedItem.sexo"
                        :rules="ruleRequired"
                        item-value="idSexo"
                        item-text="descricao"
                        :items="dropdowSexo"
                        @change="SexoSelected()"
                        chips
                        label="Sexo"
                      ></v-combobox>
                    </v-col>

                  </v-row>
          </v-container>
        </v-card-text>
</v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="!valid || (!disciplinasModeloCertificado.length)" @click="save()" color="green" >Continuar</v-btn>
           <v-btn text @click="ChamarPrepararCertificado()" v-if="dadosEditados">Pular passo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
<!-- ===================================== FIM DO MODAL ================================-->
 <!--   -->
 <v-row justify="center">
    <v-dialog v-model="dialogCert" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          <v-row>
            <v-col>
        <v-icon x-large color="yellow">report_problem</v-icon><span style="font-size:18px; font-weight:bold"> Desejas continuar essa operação?</span>
        </v-col>
        </v-row>
          </v-card-title>
        <v-card-text><span style="color:red"> Esta operação resultará na cobrança deste serviço</span>,  se desejares continuar clique em concordar</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="comporCertificado($store.state.objaluno, true, false)">Pré-vizualizar</v-btn>
          <v-btn color="green darken-1" text @click="verificarPagamentoCertificado()">Concordar</v-btn>
          <v-btn color="green darken-1" text @click="dialogCert=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- =============================================================================== -->

<!--=======================================================--========-->
  <template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
         Exportar para Excel - Deseja Continuar
        </v-card-title>

        <v-card-text>
            Clique para Continuar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="background-color:red;color:white" @click="dialog=false">Cancelar</v-btn>
           <export-excel
                :data   = "listEstudantfromPauta"
              :fields="campos"
              >
          <v-btn @click="dialog=false">Continuar</v-btn>
        </export-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </template>
<!--=================================================================-->

 </v-card>
</template>

<script>
import axios from '../../plugins/axios'
import axiosCertificado from '../../plugins/axios_api_certificado'
import axios_outside from '../../plugins/axios_outside'
import QRCode from 'qrcode'
import { mask } from 'vue-the-mask'
import Swal from 'sweetalert2'
const ls = require('local-storage')

export default {
  directives: { mask },
  data: () => ({
    readImage: ls.get('urlReport') + `readfile/`,
    configuracoesReport: [],
    generateQR: null,
    roles: 'prof',
    formValid: true,
    progresso2: false,
    overlay2: false,
    progresso: false,
    menubi: false,
    datebi: null,
    overlay: false,
    menu: false,
    dadosEditados: false,
    valid: true,
    idinstituicao: ls.get('i_id'),
    ano_actual: ls.get('anolectivo'),
    date: null,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    provincias: [],
    municipiosAll: [],
    municipiosFiltered: [],
    errorInternet: false,
    descricao: 'Nº do Bi',
    mascara: '#########-AA-###',
    on: false,
    componente: [],
    componente2: [],
    componente3: [],
    componente4: [],
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v.length <= 2) || 'valor inválido'

    ],

    json_meta: [
      [
        {
          'key': 'charset',
          'value': 'utf-8'
        }
      ]
    ],

    campos: {
      'Nome Completo': 'nome',
      'Número de Matricula': 'idMAtricula',
      'Resultado': 'resultado'
    },
    headers: [
      {
        text: 'Nome',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      { text: 'Matricula', value: 'idMAtricula' },
      { text: 'status', value: 'status' },
      { text: 'Resultado', value: 'status_resultado' },
      { text: 'Operação', value: 'action', sortable: false }

    ],
    dialogCert: false,
    html: ``,
    pdf: '',
    rascunhoimge: 'https://softlineangola.com/wp-content/uploads/2020/04/rascunho-1.png',
    url: `https://relatorios.softlineangola.com:8082/api`,
    // host: 'localhost:3000/api',
    // host: `restrito.softlineangola.com/api`,
    // host: `http://localhost:8082/api`,
    text: '',
    editedpk: false,
    temCertificado: 0,
    sexo: '',
    canPrint: [],
    certificado_dados: [],
    disciplinas: [],
    notasPcs: [],
    _classe: '',
    dialog: false,
    dialog_2: false,
    dialog_modelo_certificado: false,
    dialogoDisabilita: false,
    dialogo: false,
    estudante_obj: null,
    idanoacademico: 0,
    turmasFiltered: [],
    data_formatada: '',
    turmasAll: [],
    offset: true,
    tumaSelect: '',
    iddisciplina: 0,
    btn_description: '',
    turma_selecionada: '',
    publicar_status: false,
    isLoading: true,
    idturma: 0,
    dialogo_turma: false,
    closeOnClick: true,
    item: 1,
    listaPautasBloquadas: [],
    classe_selecionada: '',
    btn_activacao: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    disciplinasModeloCertificado: [],
    disciplinasPautaCertificado: [],
    editedIndex: -1,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      provincia: '',
      municipio: '',
      urlCertificado:(window.location.host.includes('softlineangola.com'))?'http://certificado.softlineangola.com':'http://certificado.softlineangola.net',
      dataemissaobi: null,
      rascunhoimge: 'https://softlineangola.com/wp-content/uploads/2020/04/rascunho-1.png',
      // eslint-disable-next-line no-dupe-keys
      bi: null,
      ResidenteEm: 1,
      certificado: 0,
      emitirCertificado: 0,
      instituicao: ls.get('i_id'),
      instituicaodescricao: '',
      curso: null,
      turma: null,
      flag_dados_preparados: '',
      idMAtricula: '',
      provincia: '',
      municipio:''
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      // eslint-disable-next-line no-dupe-keys
      bi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null,
      provincia:'',
      municipio:''
    },
    classes: [
      '10ª Classe',
      '11ª Classe',
      '12ª Classe',
      '13ª Classe'
    ]
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    isintegrado(){
      return ls.get('isintegrado')
    },
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    this.pautaByTurma()
    this.initializeProvincias()
    this.initializeMunicipiosAll()
    this.carregarConfiguracoesReports()
  },

  methods: {

    classe (idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this._classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this._classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this._classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
    },

    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    ChamarPrepararCertificado () {
      this.$router.push('preparar-certificado-notas')
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    IDano_academico (classe) {
      if (classe === '10ª Classe') {
        return 1
      }
      if (classe === '11ª Classe') {
        return 2
      }
      if (classe === '12ª Classe') {
        return 3
      }
      if (classe === '13ª Classe') {
        return 4
      }
    },

    teste () {
      this.dialog = true
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    backToTurmas () {
      this.$router.push('painelClassTurma')
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.pkpauta
      this.editedItem.trimestre = this.$store.state.idperfilpauta
      this.editedItem.pkpauta = item.pkpauta

      setTimeout(() => {}, 1000)
    },
    MostrarDialogo () {
      this.dialog = true
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi.toString().substring(8, 10) + '/' + datebi.toString().split('-')[1] + '/' + datebi.toString().split('-')[0]

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date().toISOString().substr(0, 10)
    },
    saveDate (date) {
      this.$refs.menu.save(date)

      this.editedItem.datanascimento = date.toString().substring(8, 10) + '/' + date.toString().split('-')[1] + '/' + date.toString().split('-')[0]

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },

    async  ContinuarMudanca () {
      this.progresso = true
      let dados =
        {
          idmatricula: this.editedItem_mudar_classe.idMAtricula,
          idanoacademico: this.IDano_academico(this.classe_selecionada)
        }

      if (dados !== null) {
        try {
          this.msg = await axios
            .post('/mudarClasse', dados)
            .then(res => res.data)
          this.progresso = false
          this.text = 'Classe Alterada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 4000 })
          this.progresso = false
          this.dialogo = false
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async ContinuarMudancaTurma () {
      this.progresso = true
      let dados = {
        idmatricula: this.editedItem_mudar_classe.idMAtricula,
        idturmaOrigem: this.editedItem_mudar_classe.idTurma,
        idturmaDestino: this.turma_selecionada
      }

      try {
        let msg = await axios
          .post('/mudarTurma', dados)
          .then(res => res.data)
        this.progresso = false
        this.text = msg
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 4000 })
        this.progresso = false
        this.dialogo_turma = false
      } catch (error) {
        this.progresso = false
        this.dialogo_turma = false
      }
    },
    bt_save (editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      editedItem.p1_MD = Math.round(
        (Number(editedItem.p1_notaMac) +
          Number(editedItem.p1_nota) +
          Number(editedItem.p1_nota2)) /
          3
      )
      editedItem.p2_MD = Math.round(
        (Number(editedItem.p2_notaMac) +
          Number(editedItem.p2_nota) +
          Number(editedItem.p2_nota2)) /
          3
      )
      editedItem.p3_MD = Math.round(
        (Number(editedItem.p3_notaMac) +
          Number(editedItem.p3_nota)) /
          2
      )
      if (this.formValid) {
        this.save(editedItem)
        Object.assign(this.listEstudantfromPauta[this.editedIndex], editedItem)

        this.editedpk = 0
      }
      setTimeout(() => {}, 1000)
    },
    backTodisciplinList () {
      if (!this.$store.state.fromMinhaTurmas) { this.$router.push('painelClassTurma') } else { this.$router.push('minhas-turmas') }
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    closeDialog(){
        this.dialog_2 = false
        this.overlay2 = false
        this.overlay = false
    },

    async save (editedItem) {
      if (this.$refs.form.validate()) {

         let htmlContent = `
            <p style="text-align: center;"><strong style="color: red;">OBS:</strong> Confirme os dados antes de guardar e continuar</p>
            <div style="width: 90%; margin: 10 auto;">
              <div style="display: grid; grid-template-columns: 150px auto;">
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.editedItem.nome}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Bilhete:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.editedItem.bi} </div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Data de emissão:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"> ${this.editedItem.dataemissaobi}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome do Pai:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.editedItem.nomedopai} </div>
                 <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome da Mãe:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"> ${this.editedItem.nomedamae}</div>
                 <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Data Nascimento:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"> ${this.editedItem.datanascimento}</div>
                 <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Sexo:</strong></div>
                 <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.sexo} </div>
                 <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Naturalidade:</strong></div>
                 <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"> ${this.proviSelectedForComb.descricao}</div>
                 <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Município:</strong></div>
                 <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.municSelectedForComb.descricao} </div>
              </div>
            </div>
           `;

          Swal.fire({
            title: "Actualização dos dados pessoais",
            html: htmlContent,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Guardar e Continuar",
            reverseButtons: true,
          }).then(async (result) => {

                let api = (true)?'/estudanteInsertOrUpdate':'/estudanteInsertOrUpdate-integrado'
            // Check the student´s age , less than 14 won´t be allowed to study on high school
            let anoNascimento = this.editedItem.datanascimento.toString().split('/')[2]
            if ((this.ano_actual - anoNascimento) >= 14 || 1=== 1) {
              this.progresso = true
              const ls = require('local-storage')
              var params = {
                pkPessoa: this.editedItem.pkPessoa,
                idPEssoa: this.editedItem.bi,
                idMunicipio: this.municSelectedForComb.idMunicipio,
                idPerfil: 1,
                nome: this.editedItem.nome,
                morada: this.editedItem.morada,
                telefone: this.editedItem.telefone,
                autor: ls.get('idPessoa'),
                datanascimento: this.editedItem.datanascimento,
                data_: this.editedItem.data_,
                resultado: this.editedItem.resultado,
                status_2: this.editedItem.status_2,
                email: this.editedItem.email,
                sexo: this.sexo,
                nomedopai: this.editedItem.nomedopai,
                nomedamae: this.editedItem.nomedamae,
                dataemissaobi: this.editedItem.dataemissaobi,
                bi: this.editedItem.bi,
                ResidenteEm: this.proviSelectedForComb.idProvincia,
                instituicao: ls.get('i_id'),
                instituicaodescricao: this.editedItem.instituicaodescricao,
                curso: { curso: this.editedItem.curso, idCurso: this.editedItem.idCurso },
                turma: { turma: this.editedItem.turma, pkTurma: this.editedItem.pkTurma },
                anolectivo: ls.get('anolectivo'),
                idanolectivo: ls.get('idanolectivo'),
                idanoacademico: this.idclasse
              }
              
              try {
                let corMensagem = 'msgError'
                let msg  = ''
                if(true){ // se a instalação for local, então vai obter os dados para o certificado na base de dados apropiada
                    msg = await axios.post(api, params).then(res => res.data)
                  }else{
                    msg = await axiosCertificado.post(api, params).then(res => res.data)
                  }
              
                // this.text = msg[1].insertId
                this.overlay2 = true
                if (msg === 'Inserção ou Actualização feita com sucesso') {
                  corMensagem = 'msgSucess'
                  // Insere na coleção
                  //this.Limpar()
                  this.ActualizaStatus()
                  if(this.temCertificado === 1)
                  {
                    this.editedItem = Object.assign({}, this.editedItem)
                    this.$store.state.objaluno = this.editedItem
                    this.$store.state.provincia = this.proviSelectedForComb.descricao;
                    this.$store.state.municipio = this.municSelectedForComb.descricao;
                    this.$store.state.listEstudantfromPauta = this.certificado_dados
                    this.overlay2 = true
                    this.progresso = false
                    this.$router.push('preparar-certificado-notas')
                      
                  }else{
                    
                    this.retornaDisciplinasParaOCertificado().then(res=>{
                        this.editedItem = Object.assign({}, this.editedItem)
                        this.$store.state.objaluno = this.editedItem
                        this.$store.state.provincia = this.proviSelectedForComb.descricao;
                        this.$store.state.municipio = this.municSelectedForComb.descricao;
                        this.$store.state.listEstudantfromPauta = this.disciplinasModeloCertificado
                        this.overlay2 = true
                        this.progresso = false
                        this.$router.push('preparar-certificado-notas')
                    })
                      //   this.ObterDisciplinasCertificado(this.estudante_obj).then((res)=>{
                      //   if(res.length){
                      //       
                      //   }else{
                      //     this.overlay2 = false
                      //     this.progresso = false
                      //     this.$store.dispatch('textMessage', { 'msg': 'O sistema não encontrou disciplinas para a emissão de certificado.', 'classMessage': 'msgError', 'timeout': 8000 })
                      //   }
                      // }).catch(error=>{
                      //   this.overlay2 = false
                      //   this.progresso = false
                      // })

                  }
                }
                if (msg === 'Número de Bi ja existente') {
                  corMensagem = 'msgError'
                }
                if (msg === 'Ocorreu um erro ao inserir') {
                  corMensagem = 'msgError'
                }
                this.text = msg
                this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 8000 })
                this.progresso = false

                //  this.close();
              } catch (error) {
                this.isLoading = false
                this.progresso = false
                this.text = error.message
                this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
              }
            } else {
              this.text = "O estudante tem a idade( '" + (this.ano_actual - anoNascimento) + "' anos ) inferior a permitida pelo sistema.( Idade minima 14 anos )"
              this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
            }
          })
        
       
      }
    },


    async retornaDisciplinasParaOCertificado(){
       this.disciplinasModeloCertificado.forEach(element => {
             let index = this.disciplinasModeloCertificado.indexOf(element)
             let disciplina = this.disciplinasPautaCertificado.filter( d=>d.iddisciplina === element.iddisciplina)
             if(disciplina.length){
                this.disciplinasModeloCertificado[index].mfd = disciplina[0].MF
                this.disciplinasModeloCertificado[index].mdf = disciplina[0].mdf
                this.disciplinasModeloCertificado[index].idPauta = disciplina[0].idPauta
                this.disciplinasModeloCertificado[index].pkPauta = disciplina[0].pkPauta
             }else{
                this.disciplinasModeloCertificado[index].mfd = null
                this.disciplinasModeloCertificado[index].mdf = null
                this.disciplinasModeloCertificado[index].idPauta = null
                this.disciplinasModeloCertificado[index].pkPauta = null
             }
        });

    },

    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
        ]
      } else {
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
        [
          // eslint-disable-next-line no-mixed-operators
          value => value.length >= 6 && value.length <= 30 || 'Minimo de caracteres exigido( 6 )'
        ]
      }
    },

    async pautaByTurma (obj) {
      // carrega turma apartir de pauta  Turma
      this.isLoading = true
      let api = (true)?'/ListaEstudantes/' + this.$store.state.objturma.pkTurma:'/ListaEstudantes-integrado/' + this.$store.state.objturma.pkTurma
      try {
        if(true){ // se a instalação for local, então vai obter os dados para o certificado na base de dados apropiada
            this.listEstudantfromPauta = await axios.get(api).then(res => res.data)
        }else{
           this.listEstudantfromPauta = await axiosCertificado.get(api).then(res => res.data)
        }
        this.isLoading = false
      } catch (error) {
       if(error.toString().includes('502')){
          this.errorInternet = true
        }else{
          this.errorInternet = false
        }
      }
    },

    async dadosPessoaisbyMatricula (matricula) {
       this.overlay = true
      try {
        return await axios_outside

          .get('/dadosPessoaisbyMatricula/'+matricula)
          .then(res => res.data)
      } catch (error) {}
    },

    async eliminarRegistroCertificado (matricula) {
       this.overlay = true
      try {
        return await axios_outside

          .get('/eliminarcertificadobymatricula/'+matricula)
          .then(res => res.data)
      } catch (error) {}
    },


     async disciplinasCertificado (instituicao,matricula) {
       this.overlay = true
      try {
        return await axios_outside

          .post('/certificadoFindMatricula',{idinstituicao:instituicao, matricula: matricula})
          .then(res => res.data)
      } catch (error) {
        console.log(error);
      }
    },

      

    Limpar () {
      this.editedItem.nome = ''
      this.editedItem.bi = ''
      this.editedItem.datanascimento = ''
      this.editedItem.nomedopai = ''
      this.editedItem.nomedamae = ''
      this.editedItem.dataemissaobi = ''
      this.editedItem.telefone = ''
    },

    SexoSelected () {
      this.sexo = this.editedItem.sexo.idSexo
    },

    async PublicarPauta () {
      const valores =
          {
            turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
            disciplina: this.$store.state.disciplina,
            bloquear: 1,
            publicar: 1,
            idControlopauta: 0
          }

      // Consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let valor = await axios

          .post('/bloquearPauta', valores)
          .then(res => res.data)
        // eslint-disable-next-line no-unused-vars
        let text = 'Pauta publicada com sucesso'
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        this.dialog = false

        this.$store.state.bloqueado = []
        // CarregaPauta
        this.CarregaPautas()
        this.verificaPautas()
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async Preparar (item) {
      
         let disciplinasCertificado = await this.disciplinasCertificado(item.instituicao,item.idMatricula)
         if( disciplinasCertificado.length === item.numero_disciplinas){  // Estudante já emitiu certificado  
              this.overlay = false
              this.certificado_dados = disciplinasCertificado
              this.disciplinasModeloCertificado = disciplinasCertificado
              this.disciplinasPautaCertificado = disciplinasCertificado
              this.editedItem = Object.assign(this.editedItem,item)
              this.proviSelectedForComb = null //this.provincias.filter( p=>p.descricao ===  this.editedItem.provincia)[0]
              this.municSelectedForComb = null //this.municipiosAll.filter( m=>m.descricao === this.editedItem.municipio )[0]
              this.estudante_obj = item
              this.dialog_2 = true
              this.sexo = this.editedItem.sexo
              this.temCertificado = 1
         }else{
           this.overlay = false
           this.temCertificado = 0
            // let result = await this.eliminarRegistroCertificado(item.idMatricula)
            //--------- Verifica se já existe o modelo de certificado para este curso e se existir obtem os dados ...======================
            this.verifyModeloCertificado(item).then(async (res)=>{
              if( !res.length ){
                  this.dialog_modelo_certificado = true
              }else{
                  this.disciplinasModeloCertificado = res[0]
                  this.editedItem = Object.assign(this.editedItem,item)
                  this.estudante_obj = item
                  this.dialog_2 = true
                  this.sexo = this.editedItem.sexo
                  this.proviSelectedForComb = this.provincias.filter( p=>p.descricao ===  this.editedItem.provincia)[0]
                  this.municSelectedForComb = this.municipiosAll.filter( m=>m.descricao === this.editedItem.municipio )[0]
                  let disciplinasPauta = await this.ObterDisciplinaPautaToCertificado({matricula:item.idMatricula})
                  this.disciplinasPautaCertificado = disciplinasPauta
                  this.overlay2 = false
              }
            }).catch(error=>{
               this.temCertificado = 0
               this.overlay = false
            })
         }
    },

    async ObterDisciplinaPautaToCertificado(item){
        try {
          this.overlay2 = true
          return    await axios

            .post('/ObterDisciplinasPautaToCertificado', item)
            .then(res => res.data)
            
        } catch (error) {
        } finally{
          this.overlay2 = false
        }
    },

    async ObterDisciplinasCertificado (item){
      this.progresso = true
      try {
          // eslint-disable-next-line no-unused-vars
          return    await axios

            .post('/obter-disciplinas-pauta-modelo', item)
            .then(res => res.data)
        } catch (error) {
          }
    },

    async ObterModeloCertificado (){

    },

     async loginCertificado (token,username){
       
        try {
        return await axios_outside
          .post('/login',{token:token,username:username,source:'Maianga'})
          .then(res => res.data)
      } catch (error) {}
    },


    async UsuarioCertificadoInsertOrUpdate (params){
       
        try {
        return await axios_outside
          .post('/usuarioInsertOrUpdate',params)
          .then(res => res.data)
      } catch (error) {}
    },

   async verifyModeloCertificado (item){
      try {
          return    await axios
            .post('/verifica-existencia-modelo', item)
            .then(res => res.data)
        } catch (error) {
        }
    },

    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },

    async DesbloquearPauta () {
      // Verificando se o Id esta disponivel
      if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores =
            {
              turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
              disciplina: this.$store.state.disciplina,
              bloquear: 0,
              publicar: 0,
              idControlopauta: this.$store.state.Controlopauta
            }

        try {
          // eslint-disable-next-line no-unused-vars
          let valor = await axios

            .post('/bloquearPauta', valores)
            .then(res => res.data)
          // eslint-disable-next-line no-unused-vars
          let text = 'Pauta Bloqueada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          this.dialog = false

          this.$store.state.bloqueado = []
          // CarregaPauta
          this.CarregaPautas()
          this.verificaPautas()

          this.dialogoDisabilita = false
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },
// elimina o registro incorrecto em certificado
           //let result = await this.eliminarRegistroCertificado(item.idMatricula)
    async ActualizaStatus () {
      try {
        // eslint-disable-next-line no-unused-vars
        let valor = await axios

          .get('/ActualizaStatusFlagEditar/' + this.editedItem.pkPessoa)
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async obterDadosPauta (objaluno){
       try {
        // eslint-disable-next-line no-unused-vars
        this.notasPcs = await axios

          .post('/obterpcMediafromPauta' ,objaluno)
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    rascunho (putRascunho) {
      return putRascunho === true ? this.rascunhoimge : ''
      // return ''
    },

    async certificadoPago (item) {
      this.$store.state.objaluno = item
      try {
        this.certificadosPago = await axios
          .get('/certificadoPago/' + item.pkPessoa)
          .then(res => res.data)
        // Se o certificado estiver pago então enviar-se-á os dados do aluno e a permissão de imprimir sem o rascunho
        // Se o certificado não estiver pago então checamos se a saldo disponivel nesta instituição
        if (this.certificadosPago.length > 0) { 
          this.obterDadosPauta(this.$store.state.objaluno).then(()=>{
            this.comporCertificado(item, false, false) 
          })
        } else { this.verificarPagamentoCertificado() }
      } catch (error) {
        this.text = error
      }
    },
    async  verificarPagamentoCertificado () {
      this.dialogCert = false
      try {
        this.canPrint = await axios
          .get('/verificarPagamento/' + this.$store.state.objaluno.instituicao)
          .then(res => res.data)

        if (this.canPrint.length && this.canPrint[0].quantidade_final > this.canPrint[0].consumo) {
          this.obterDadosPauta(this.$store.state.objaluno).then(()=>{
            this.comporCertificado(this.$store.state.objaluno, false, true)
          })
        } else {
          // Imprimir com o rascunho e não fará desconto
          this.obterDadosPauta(this.$store.state.objaluno).then(()=>{
            this.comporCertificado(this.$store.state.objaluno, true, false)
          })
          
        }
      } catch (error) {
        this.text = error
      }
    },
    async comporCertificado (dados, isRascunho, canDescontar) {
           let certificadoUrl = (ls.get('ims') === 'IMS-Luanda')?'http://certificado.softlineangola.com':'http://certificado.softlineangola.net'
          // let certificadoUrl = 'http://localhost:8085'
          window.open(certificadoUrl+'/#/?q=' + dados.idMAtricula + '/' + ls.get('token'), '_blank').focus()
    },
    async gerarPdfCertificado (option, canDescontar) {
      this.progresso2 = true
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile', //  http://relatorios.softlineangola.com
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: option
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF
        this.progresso2 = false
        this.frameCertificado(canDescontar)
      } catch (error) {
        
        this.progresso2 = false
      }
    },
    frameCertificado (canDescontar) {
      if (canDescontar) {
        this.descontarEmulumentoPago()
        this.insertImprimirCertificado(this.$store.state.objaluno)
      }
      let link = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
      this.progresso2 = false
    },
    async descontarEmulumentoPago () {
      // eslint-disable-next-line no-unused-vars
      let descontandoEmolumento
      const value = {
        pkpagamentoEmolumento: this.canPrint[0].pkpagamentoEmolumento,
        consumo: ((this.canPrint[0].consumo) + 1),
        idPessoa: ls.get('nomeUsuario')
      }
      try {
        descontandoEmolumento = await axios
          .post('/DescontarEmolumentoPago', value)
          .then(res => res.data)
      } catch (error) {
        console.log('A API DescontandoEmolumento) ' + error)
        this.text = error
      }
    },
    async insertImprimirCertificado (item) {
      const value = {
        pkPessoa: item.pkPessoa,
        matricula: item.idMatricula,
        autor: ls.get('nomeUsuario')
      }
      try {
        // eslint-disable-next-line no-unused-vars
        let insertCertificadoPago = await axios
          .post('/insertImprimirCertificado', value)
          .then(res => res.data)
      } catch (error) {
        this.text = error
      }
    },
    extensao (valor) {
      switch (valor) {
        case '10':
          return 'Dez'
        case '11':
          return 'Onze'
        case '12':
          return 'Doze'
        case '13':
          return 'Treze'
        case '14':
          return 'Catorze'
        case '15':
          return 'Quinze'
        case '16':
          return 'Dezasseis'
        case '17':
          return 'Dezassete'
        case '18':
          return 'Dezoito'
        case '19':
          return 'Dezanove'
        case '20':
          return 'Vinte'
        case 10:
          return 'Dez'
        case 11:
          return 'Onze'
        case 12:
          return 'Doze'
        case 13:
          return 'Treze'
        case 14:
          return 'Catorze'
        case 15:
          return 'Quinze'
        case 16:
          return 'Dezasseis'
        case 17:
          return 'Dezassete'
        case 18:
          return 'Dezoito'
        case 19:
          return 'Dezanove'
        case 20:
          return 'Vinte'

        default:
          return 'Valor inválido'
      }
    },

    convertDate (dateString) {
      var p = dateString.split('-')
      // eslint-disable-next-line standard/array-bracket-even-spacing
      return [p[2], p[1], p[0] ].join('/')
    },
    monthName () {
      let d = new Date()
      let month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return month[d.getMonth()] + ' ' + 'de' + ' ' + (d.getFullYear()).toString()
    },
    dia () {
      var day = new Date()
      day = day.getDate()
      day = day.toString()
      return day
    },
    async carregarConfiguracoesReports () {
      try {
        let msg = await axios
          .post('/configuracoes', { empresa: 'report' })
          .then(res => res.data)
        // console.log(msg)
        if (msg.length > 0) {
          this.configuracoesReport = msg
        }
      } catch (error) {

      }
    },
    verificaPautas () {
      this.listaPautasBloquadas = this.$store.state.bloqueado.filter(block => block.turma === this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma && block.disciplina === this.$store.state.disciplina && block.publicar === 1 && block.bloquear === 1)
      if (this.listaPautasBloquadas.length) {
        this.$store.state.Controlopauta = this.listaPautasBloquadas[0].idControlopauta
        if (ls.get('role') === 'ROLE_PROF') {
          this.publicar_status = true
          this.btn_activacao = true
          this.btn_description = 'Mini Pauta Bloqueada'
        } else {
          this.publicar_status = true
          this.btn_activacao = false
          this.btn_description = 'Mini Pauta Bloqueada'
        }
      } else {
        this.publicar_status = false
        this.btn_activacao = false
        this.btn_description = 'Publicar'
      }
    },

    editItem (item) {
      this.$store.state.objAluno = item
      this.$router.push('Boletim')
    },

    async findDisciplinaInProfDisc (obj) {
      this.disciplinas = []
      this.$store.state.turma = obj.descricao
      this.$store.state.objturma = obj
      try {
        this.disciplinas = await axios

          .get('/findDisciplinaInProfDisc/' + obj.pkTurma)
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async Mudar_Classe (item) {
      this.dialogo = true
      this.editedItem_mudar_classe = Object.assign({}, item)
      this.classe(this.editedItem_mudar_classe.idAno_Academico)
      let indice = this.classes.indexOf(this._classe)
      this.classes.splice(indice, 1)
    }
  }
}
</script>
